import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import classNames from 'classnames';
import { bemModifier } from 'utils/BEMHelper';

import styles from './TagLabel.scss';

const TagLabel = ({
  small,
  label,
  primary,
  secondary,
  className,
  warning,
  risk,
  light,
  uppercase,
}) => {
  const stylesName = classNames(
    ...bemModifier('a-tag-label', {
      small,
      primary,
      secondary,
      warning,
      risk,
      light,
      uppercase,
    }),
  );

  return (
    <div styleName={stylesName} className={className}>
      <div styleName="a-tag-label__title">{label}</div>
    </div>
  );
};

TagLabel.propTypes = {
  small: PropTypes.bool,
  label: PropTypes.string,
  className: PropTypes.string,
  primary: PropTypes.bool,
  secondary: PropTypes.bool,
  warning: PropTypes.bool,
  risk: PropTypes.bool,
  light: PropTypes.bool,
  uppercase: PropTypes.bool,
};

export default CSSModules(TagLabel, styles, { allowMultiple: true });
